import React from 'react';
import PropTypes from 'prop-types';
import ButtonCTA from '@tcp/core/src/components/common/molecules/ButtonCTA';
import Container from '../styles/CtaItems.style';

const CTAItem = ({ ctaItems }) => {
  return (
    <Container className="cta-wrapper">
      {ctaItems.map((item, index) => (
        <ButtonCTA
          key={index}
          className={`cta-button-${index} ${item.variation || ''}`.trim()}
          uniqueKey={`cta-button-${index}`}
          ctaInfo={{
            ctaVariation: 'linkCTAList',
            link: {
              url: item.url,
              title: item.title,
              text: item.text,
              styledObjWeb: item.styledObjWeb,
            },
          }}
        />
      ))}
    </Container>
  );
};

CTAItem.propTypes = {
  ctaItems: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      title: PropTypes.string,
      target: PropTypes.string,
      variation: PropTypes.string,
      styledObjWeb: PropTypes.string,
    })
  ).isRequired,
};

export default CTAItem;
